import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1335207a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1335207a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335207a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1335207a')) {
      api.createRecord('1335207a', component.options)
    } else {
      api.reload('1335207a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1335207a&scoped=true&", function () {
      api.rerender('1335207a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0LlPeIvmngg/JS/comp/GuestBox.vue"
export default component.exports